<div class="followed-companies">
  <div class="followed-companies__hero">
    <div class="vacancy-hero">
      <h1 class="vacancy-hero__title">{{ 'companies.followed.hero_title' | translate }}</h1>
      <p class="vacancy-hero__subtitle" *ngIf="followedCompanies.length > 0">{{ 'companies.followed.subtitle_prefix' | translate }} {{ followedCompanies.length }} {{ 'companies.followed.subtitle_suffix' | translate }}</p>
    </div>
  </div>

  <div class="vacancy-container followed-companies__content">
    <div class="vacancy-empty-state" *ngIf="followedCompanies.length === 0">
      <h2 class="vacancy-empty-state__title">{{ 'companies.followed.empty_title' | translate }}</h2>
      <p class="vacancy-empty-state__text">{{ 'companies.followed.empty_text' | translate }}</p>
      <a routerLink="/profile-check/companies/discover" class="followed-companies__discover-link">{{ 'companies.followed.discover_link' | translate }}</a>
    </div>

    <div class="vacancy-grid" *ngIf="followedCompanies.length > 0">
      <bwc-company-card
        *ngFor="let company of followedCompanies"
        [company]="company"
        [isFollowed]="true"
        (followed)="unfollow($event)"
      ></bwc-company-card>
    </div>
  </div>
</div>
